import { useContext, useEffect, useState } from "react";
import { StoryContext } from "../context/StoryContext";
import StoryCard from "../components/StoryCard";

const Home = () => {

  const {
    stories = [],
    toggleBookmark,
    getStories,
    totalPages,
  } = useContext(StoryContext);

  const [page, setPage] = useState(1);

  // PAGE CHANGE API CALL
  useEffect(() => {

    getStories(page);

  }, [page]);

  // BOOKMARK HANDLE
  const handleBookmark = (story) => {

    toggleBookmark(story);

    alert("Bookmark added successfully");
  };

  return (
    <div style={{ padding: "20px" }}>

      <h1>Top Hacker News Stories</h1>

      {/* STORIES */}
      {Array.isArray(stories) && stories.length > 0 ? (

        stories.map((story) => (

          <StoryCard
            key={story._id}
            story={story}
            toggleBookmark={handleBookmark}
          />

        ))

      ) : (

        <p>Loading stories...</p>

      )}

      {/* PAGINATION */}
      <div
        style={{
          display: "flex",
          gap: "10px",
          justifyContent: "center",
          marginTop: "30px",
        }}
      >

        {/* PREVIOUS */}
        <button
          disabled={page === 1}
          onClick={() => setPage(page - 1)}
          style={{
            padding: "10px 20px",
            cursor: "pointer",
          }}
        >
          Previous
        </button>

        {/* PAGE NUMBER */}
        <button
          style={{
            padding: "10px 20px",
            background: "#2563eb",
            color: "#fff",
            border: "none",
          }}
        >
          {page}
        </button>

        {/* NEXT */}
        <button
          disabled={page === totalPages}
          onClick={() => setPage(page + 1)}
          style={{
            padding: "10px 20px",
            cursor: "pointer",
          }}
        >
          Next
        </button>

      </div>

    </div>
  );
};

export default Home;